import { gql } from "@apollo/client";
import { verification } from "./fragments";
import { messageHeaders } from "features/common/fragments";

export const DOCUMENT_VERIFICATION_UPDATED = gql`
  subscription documentVerificationUpdated {
    documentVerificationUpdated {
      verification {
        ...verification
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${verification}
  ${messageHeaders}
`;
